import { Employee } from 'app/models/employee';

export class SetEmployees {
  static readonly type = '[Employee Service] SetEmployees';
  constructor(public employees: Employee[]) {}
}
